<template>
  <div class="forget-password">
    <!-- 标题 -->
    <div style="padding: 10px;">
      <img :src="protectEasyLogo" style="width: 115px;">
    </div>
    <!--忘记密码  -->
    <div class="forget-password-content">
      <Form ref="formValidatForgetPassword" :model="formValidatForgetPassword" :rules="ruleValidate">
        <h3 class="forget-password-title">{{ $t('common.forgetPassword') }}</h3>
        <Row :gutter="11">
          <Col span="18">
            <!-- 邮件 -->
            <FormItem prop="email" class="forget-password-user">
              <Icon type="md-mail" class="forget-password-icon"/>
              <input  v-model="formValidatForgetPassword.email" style="width: 250px;" :placeholder="$t('permission_configuration_management.register.Mailbox')" />
            </FormItem>
          </Col>
          <Col span="4">
            <Button type="primary" style="height: 50px;" @click="sendVerificationCode('formValidatForgetPassword')">{{$t('permission_configuration_management.register.SendTheVerificationCode')}}</Button>
          </Col>
        </Row>
        <!-- 验证码 -->
        <FormItem prop="verificationCode" class="forget-password-user">
          <Icon type="md-lock" class="forget-password-icon"/>
          <input v-model="formValidatForgetPassword.verificationCode" style="width: 395px;"  :placeholder="$t('permission_configuration_management.register.VerificationCode')"/>
        </FormItem>
        <Button type="primary" @click="nextStep('formValidatForgetPassword')" long>{{$t('permission_configuration_management.register.NextStep')}}</Button>
      </Form>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        protectEasyLogo: require('../../../../../static/images/silverlining-logo.png'),
        formValidatForgetPassword: {
          email: '',
          verificationCode: ''
        },
        ruleValidate: {
          email: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
            {type: 'email', message: '邮箱格式错误', trigger: 'blur'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      // 发送邮箱获取验证码
      sendVerificationCode: function (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.user.sendVerificationCode({
              "name": this.$route.query.userName || "",
              "email": this.formValidatForgetPassword.email
            })
              .then(res => {
                this.formValidatForgetPassword.email = res.data.email;
                this.$Message.success('发送成功，5分钟内有效!');
              })
          } else {
            this.$Message.error('邮箱不存在!');
          }
        })
      },
      // 下一步
      nextStep: function (name){
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.user.nextStep({
              "name": this.$route.query.userName || "",
              "email": this.formValidatForgetPassword.email,
              "verificationCode": this.formValidatForgetPassword.verificationCode
            })
              .then(res => {
                // 路由跳转到修改密码界面 并传参数过去
                this.$router.push({
                  path: '/changePassword',
                  query: {
                    verificationCode : this.formValidatForgetPassword.verificationCode,
                    email : this.formValidatForgetPassword.email
                  }
                });
                this.$Message.success('验证成功!');
              })
          } else {
            this.$Message.error('修改失败!');
          }
        })
      }
    }
  }
</script>
<style scoped>
  .forget-password {
    position: fixed;
    left: 0;
    right: 0;
    background-color: #2d3a4b;
    top: 0;
    bottom: 0;
  }

  .forget-password-content {
    width: 448px;
    height: 330px;
    margin-top: -165px;
    margin-left: -181px;
    position: fixed;
    top: 45%;
    left: 47%;
  }

  .forget-password-title {
    font-size: 26px;
    color: #eee;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .forget-password-user {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
    line-height: 52px;
    height: 52px;
    font-size: 14px;
    margin-bottom: 18px;
  }

  .forget-password-user input {
    background: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: #eee;
    height: 47px;
    outline: none;
  }

  .forget-password-icon {
    padding-left: 13px;
    color: #889aa4;
    font-size: 18px;
    margin-top: -4px;
  }

  .forget-password-content Button {
    height: 40px;
    font-size: 14px;
    margin-bottom: 22px;
  }
  .forget-password-content >>> .ivu-select-selection {
    background: transparent;
    border: 0;
    box-shadow: none;
  }

  .forget-password-content >>> .ivu-select-selected-value {
    color: #fff;
  }

  .forget-password-content >>> .ivu-select-arrow {
    position: absolute;
    top: 50%;
    right: 8px;
    line-height: 1;
    transform: translateY(-50%);
    font-size: 14px;
    color: #808695;
    transition: all .2s ease-in-out;
  }

  .forget-password-content >>> .ivu-select-placeholder {
    color: #707070;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/ForgetPassword.vue